export const environment = {
  production: false,
  env: 'uat',
  msalConfig: {
    auth: {
      clientId: '7c716a94-4907-4354-a3d0-bce4ba8812d4',
      authority:
        'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiUrl: 'https://api.cit-assist-uat.ey.net/',
};
